import querySerializer from 'query-string';
import { MDTAnalytics } from 'mdt-core-components/src/services/mdtanalytics.js';

// The purpose of the below options is to demonstrate auth filtering.
// onBeforeChange fires before going to a new route, and you can
// redirect if certian conditions aren't met.

export default {
    querySerializer,
    onBeforeChange: (dispatch, getState, action) => {
        const {
            location: { routesMap },
        } = getState();

        // Capturing initial time of any page (Components) load
        window.pageLoadStartTime = new Date().getTime();

        const { type } = action.action;

        // Tracking Pages on Route change.
        MDTAnalytics.track({
            pageInfo: {
                pageName: type,
                pagePath: routesMap[type],
                widgetName: 'N/A',
            },
        });
    },
    onAfterChange: () => {},
};
